// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__ZapKg","Link":"Contacts_Link__Wq-Lp"};